import React from "react";

const Sites = () => {

    return(
        <>
 <div className="flex justify-center items-center mx-auto">
  <img className="flex justify-center items-center mx-auto" src="images/Maps.png" alt="Map" />
</div>

        </>
    )
}

export default Sites;